import React,{Component} from "react";
import people from "../../Images/People.png";
import memberlogo from "../../Images/Member-logo.png";
import coursereport from "../../Images/course-report.png";
import exam from "../../Images/Exam.png";
import memorandum from "../../Images/Memorandum.png";
import journal from "../../Images/Journal.png"
import { tarbookService } from "../../services/tarbook.service";
import { historypush } from "../../_helpers/utilities";
import Loader from "../../_helpers/Loader";
import process from "../../Images/process.png";
import analysis from "../../Images/analysis.png";
import docFile from "../../Images/File/ORP-March-2020.docx";
import WMTCIcon from "../../Images/WMTC Icon.png";

class memberdetails extends Component{
    constructor(props){
        super(props);
        this.state={
            isLoading:false,
            memberCount:0,
        }

    }

    componentDidMount=async()=>{
        this.setState({
            isLoading:true,
        })
        const userID = localStorage.getItem("UserID");
        const grade = localStorage.getItem("Grade");

        const Role = localStorage.getItem("RoleId");
        if(Role != 3){
            document.getElementById("show-memberportal").style.display = 'none';
        }
        if(Role == 3){
            var response=await tarbookService.GetDashboardDetails(userID,grade);
            if(response.status===200){
                this.setState({
                    memberCount : response.data.memberCount,
                    isLoading:false,
                })
            }else if(response.status===401){
                localStorage.clear();
                historypush('/login');
            }
        }else{
            historypush('/login');
        }
    }

    downloadpdf=()=>{
        const link = document.createElement('a');
        link.href = "https://wpimei.casebook.in/wp-content/uploads/2022/07/ORP-March-2020.docx";
        link.download = 'ORP-March-2020.docx';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    searchMemberClick=()=>{
        historypush('/searchMember');
    }

    render(){
        const{
            memberCount,
            isLoading
        }=this.state;
        return(
            <div className="member-body" id="show-memberportal">
                {isLoading && <Loader />}
                <div className="about">
                    <div className="container">
                        <h3 className="heading">IME(I) Members Area</h3>
                        <div className="row info-data">
                            <div className="col-xxl-4 col-xl-6 col-lg-6 col-sm-12">
                                <div className="boxed student-course-detail">
                                <div className="table-responsive-sm">
                                    <table className="table" style={{marginBottom:'25px'}}>
                                    <tbody>
                                        <tr>
                                        <td colSpan={1}><img src={memberlogo} alt="group-member" className="member" /></td>
                                        <td className="src-people" colSpan={1} onClick={()=>this.searchMemberClick()} style={{cursor:'pointer'}} >
                                            <img src={people} alt="people" />
                                            <h6>Search Member</h6>
                                        </td>
                                        </tr>
                                    </tbody>
                                    </table>
                                </div>
                                <div className="table-responsive-sm mbr-report-data">
                                    <table className="table">
                                    <tbody>
                                        <tr>
                                        <td className="mbr-data">
                                            <h4>Total Members</h4>
                                        </td>
                                        <td className="mbr-report green-color"><h2 style={{color: '#8BB700'}}>{memberCount}</h2></td>
                                        </tr>
                                    </tbody>
                                    </table>
                                </div>
                                </div>
                            </div>
                            <div className="col-xxl-4 col-xl-6 col-lg-6 col-sm-12">
                                <div className="boxed student-course-detail">
                                <div className="table-responsive-sm mbr-report-data">
                                    <table className="table">
                                    <tbody>
                                        <tr>
                                        <td><img src={coursereport} alt="course-report" />
                                            <br /><h4 className="course-report">Reports</h4></td>
                                        <td>							
                                            <ul className="question">
                                            <li><a href="/37th-annual-general-meeting-27th-december-2020/">37th Annual General Meeting 27th December 2020</a></li>
                                            </ul>
                                        </td>
                                        </tr>
                                    </tbody>
                                    </table>
                                    <table className="table" style={{marginTop:'20px'}}>
                                    <tbody>
                                    <tr>
                                        <td style={{width:"28%"}}></td>
                                        <td className="cse-report">
                                        <a className="orange-color"
                                            style={{cursor:'pointer', padding:'7px'}}
                                            download
                                            onClick={()=>this.downloadpdf()}
                                        >
                                            {/* <a href="/#0" className="orange-color"> */}
                                            <img src={process} alt="OPR" style={{width:"35px",marginRight:"7px"}} />
                                            <span className="gray-color">ORP</span>
                                            </a>
                                        </td>
                                        <td className="cse-report">
                                            <a className="orange-color" href="/governing-council-reports" style={{padding:'7px'}} >
                                            <img src={analysis} alt="gcreports" style={{width:"35px",marginRight:"7px"}} />
                                            <span className="gray-color">GC Reports</span>
                                            </a>
                                        </td>
                                    </tr>
                                    </tbody>
                                    </table> 
                                </div>
                                </div>
                            </div>
                            <div className="col-xxl-4 col-xl-6 col-lg-6 col-sm-12">
                                <div className="boxed exam-detail student-course-detail">
                                <div className="table-responsive-sm">
                                    <img src={exam} alt="exam" className="exams" />
                                    <ul className="question" style={{color:'#212529', paddingLeft:'8px'}}>
                                        <li><a href="/questionbank">Question Bank</a></li>
                                        <li><a href="/questionsandanswersformeoexams">Questions &amp; Answers for MEO Exams</a></li>
                                        <li><a href="/part-time-examiners">Part Time Examiners</a></li>
                                    </ul>
                                </div>
                                </div>
                            </div>
                            <div className="col-xxl-4 col-xl-6 col-lg-6 col-sm-12">
                                <div className="boxed exam-detail student-course-detail">
                                <div className="table-responsive-sm">
                                    <img src={WMTCIcon} alt="exam" className="exams" />
                                    <ul className="question" style={{color:'#212529', paddingLeft:'8px'}}>
                                        <li><a href="/wmtc-2018-papers">WMTC 2018 Papers</a></li>
                                        <li><a href="/wmtc-2009-papers">WMTC 2009 Papers</a></li>
                                    </ul>
                                </div>
                                </div>
                            </div>
                        
                        <div className="col-xxl-4 col-xl-6 col-md-12 col-12">
                            <div className="boxed memorandum journal-table">
                            <div className="row">
                                <div className="col-lg-4 col-md-3 col-sm-12">
                                <img src={memorandum} alt="Memorandum" />
                                </div>
                                <div className="col-lg-8 col-md-9 col-sm-12">
                                <div className="Memorandum-data">
                                    <div className="table-responsive-sm">
                                    <table className="table">
                                        <tbody>
                                        <tr>
                                            <td><h3>Memorandum &amp; Articles of Association</h3></td>
                                        </tr>
                                        <tr>
                                            <td><h4>Memorandum of Association for the Establishment of The Institute of Marine Engineers (India) in the matter of Act XXI of 1860</h4></td>
                                        </tr>
                                        <tr>
                                            <td><a href="https://wpimei.casebook.in/memorandum-articles-of-association/" className="View-All">View All</a></td>
                                        </tr>
                                        </tbody>
                                    </table>
                                    </div>
                                </div>
                                </div>
                            </div>
                            </div>
                        </div>
                        <div className="col-xxl-4 col-md-12 col-xl-6 col-12">
                            <div className="boxed journal journal-table">
                            <div className="row">
                                <div className="col-lg-4 col-md-3 col-sm-12">
                                <img src={journal} alt="Journal" />
                                </div>
                                <div className="col-lg-8 col-md-9 col-sm-12">
                                <div className="journal-data">
                                    <div className="table-responsive-sm">
                                    <table className="table">
                                        <tbody>
                                        <tr>
                                            <td><h3>Journal</h3></td>
                                        </tr>
                                        <tr>
                                            <td><h4>A Dive into Sub-sea Power System</h4></td>
                                        </tr>
                                
                                        <tr className="journal-link">
                                            <td><a href="https://imaremerjournal.in/" rel="noreferrer" target="_blank">Read MER Online</a></td>
                                            <td />
                                            <td><a href="https://wpimei.casebook.in/journal/" className="View-All">View All</a></td>
                                        </tr>
                                        </tbody>
                                    </table>
                                    </div>
                                </div>
                                </div>
                            </div>
                            </div>
                        </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default memberdetails;